import React from 'react';
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Button } from '@dsi/react-eds';
import styles from './Support.module.css';

const Support: React.FC = () => {
  const handleSupportClick = () => {
    console.log('Get Support clicked');
  };

  return (
    <div className={styles.support}>
      <div className={styles.supportContent}>
        <div className={styles.supportTextSection}>
          <h3 className={styles.supportTitle}>RAN LCA Support</h3>
          <p className={styles.supportDescription}>
            If you need assistance, our support team is here to help. You can reach us and we’ll get back to you as soon as possible.
          </p>
          <div className={styles.supportAction}>
            <ReactEDSWrapper component={Button} primary onClick={handleSupportClick}>
              Support Channel
            </ReactEDSWrapper>
          </div>
        </div>
        <div className={styles.supportImageSection}>
          <img src="/images/home-support-item.png" alt="RAN LCA Support" className={styles.supportImage} />
        </div>
      </div>
    </div>
  );
};

export default Support;
